class GspGallery extends HTMLElement {
connectedCallback() {
this.slides = [...this.querySelectorAll('[data-gsp-slide]')];
this.thumbs = [...this.querySelectorAll('[data-gsp-thumb]')];
this.label = this.querySelector('[data-gsp-label]');
this.channel = this.label?.parentElement;
this.index = 0;
this.querySelector('[data-gsp-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
this.querySelector('[data-gsp-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.go(index, true)));
const seconds = Number(this.dataset.autoplay);
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (seconds > 0 && this.slides.length > 1 && !reducedMotion) {
this.timer = setInterval(() => this.go(this.index + 1, false), seconds * 1000);
}
}
disconnectedCallback() {
clearInterval(this.timer);
}
go(target, fromUser) {
if (fromUser) clearInterval(this.timer);
if (!this.slides.length) return;
this.index = (target + this.slides.length) % this.slides.length;
this.slides.forEach((slide, index) => {
slide.hidden = index !== this.index;
});
this.thumbs.forEach((thumb, index) => {
if (index === this.index) thumb.setAttribute('aria-current', 'true');
else thumb.removeAttribute('aria-current');
});
if (this.label && this.channel) {
const number = String(this.index + 1).padStart(2, '0');
this.label.textContent = this.slides[this.index]?.dataset.label ?? '';
this.channel.firstChild.textContent = `CH ${number} · `;
}
}
}
class GspOffers extends HTMLElement {
connectedCallback() {
this.addEventListener('change', (event) => {
const input = event.target;
if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
this.sync(input.value);
this.updateUrl(input.value);
});
const checked = this.querySelector('input[type="radio"]:checked');
if (checked instanceof HTMLInputElement) this.sync(checked.value);
}
sync(variantId) {
const scope = this.closest('[data-gsp-hero]');
if (!scope) return;
scope.querySelectorAll('[data-gsp-variant]').forEach((element) => {
if (element instanceof HTMLElement) element.hidden = element.dataset.gspVariant !== variantId;
});
scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((input) => {
if (input instanceof HTMLInputElement) input.value = variantId;
});
}
updateUrl(variantId) {
if (!window.location.pathname.includes('/products/')) return;
const url = new URL(window.location.href);
url.searchParams.set('variant', variantId);
window.history.replaceState({}, '', url);
}
}
class GspSticky extends HTMLElement {
connectedCallback() {
const hero = this.closest('[data-gsp-hero]');
const form = hero?.querySelector('form[data-type="add-to-cart-form"]');
const target = hero?.querySelector('gsp-buy');
this.querySelector('button')?.addEventListener('click', () => {
if (form instanceof HTMLFormElement) form.requestSubmit();
});
if (target) {
this.observer = new IntersectionObserver(([entry]) => {
this.toggleAttribute('data-visible', !entry.isIntersecting);
});
this.observer.observe(target);
} else {
this.setAttribute('data-visible', '');
}
}
disconnectedCallback() {
this.observer?.disconnect();
}
}
class GspReviews extends HTMLElement {
connectedCallback() {
const button = this.querySelector('[data-gsp-review-more]');
button?.addEventListener('click', () => {
this.querySelector('[data-gsp-review-grid]')?.classList.add('is-all');
button.remove();
});
}
}
const cartRoot = () => window.Shopify?.routes?.root ?? '/';
class GspCart extends HTMLElement {
get dialog() {
return this.querySelector('[data-gsp-cart-dialog]');
}
connectedCallback() {
this.addEventListener('click', (event) => {
const button = event.target.closest('[data-gsp-remove]');
if (button) this.change(button.dataset.gspRemove, 0);
});
}
open() {
if (!this.dialog.open) this.dialog.showModal();
}
async request(path, body) {
const response = await fetch(cartRoot() + path, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ ...body, sections: [this.dataset.sectionId], sections_url: window.location.pathname }),
});
const data = await response.json();
if (!response.ok) throw new Error(data.description || data.message || 'A kosár frissítése nem sikerült.');
this.render(data.sections?.[this.dataset.sectionId]);
return data;
}
render(html) {
if (!html) return;
const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gsp-cart-content]');
const current = this.querySelector('[data-gsp-cart-content]');
if (!next || !current) return;
current.replaceWith(next);
document.querySelectorAll('[data-gsp-cart-count]').forEach((element) => {
element.textContent = next.dataset.count;
});
}
add(variantId, quantity) {
return this.request('cart/add.js', { items: [{ id: Number(variantId), quantity }] });
}
change(lineKey, quantity) {
return this.request('cart/change.js', { id: lineKey, quantity });
}
}
class GspBuy extends HTMLElement {
connectedCallback() {
const form = this.querySelector('form');
const error = this.querySelector('[data-gsp-buy-error]');
form?.addEventListener('submit', async (event) => {
const cart = document.querySelector('gsp-cart');
if (!cart) return;
event.preventDefault();
const button = form.querySelector('button[type="submit"]');
button.disabled = true;
if (error) error.hidden = true;
try {
await cart.add(form.elements.id.value, Number(form.elements.quantity.value) || 1);
window.location.assign(`${cartRoot()}checkout`);
return;
} catch (failure) {
if (error) {
error.textContent = failure.message;
error.hidden = false;
}
} finally {
button.disabled = false;
}
});
}
}
document.addEventListener('click', (event) => {
const target = event.target;
if (!(target instanceof Element)) return;
const opener = target.closest('[data-gsp-open]');
if (opener) document.getElementById(opener.dataset.gspOpen)?.showModal();
if (target.closest('[data-gsp-open-cart]')) document.querySelector('gsp-cart')?.open();
const closer = target.closest('[data-gsp-close]');
if (closer) closer.closest('dialog')?.close();
if (target instanceof HTMLDialogElement && target.matches('[data-gsp-drawer]')) target.close();
});
const canPlayGifs = () => {
const connection = navigator.connection;
if (!connection) return true;
return !connection.saveData && !/2g|3g/.test(connection.effectiveType ?? '');
};
const playGif = (image) => {
const source = image.dataset.gspGif;
if (!source) return;
delete image.dataset.gspGif;
const loader = new Image();
loader.onload = () => {
image.removeAttribute('srcset');
image.removeAttribute('sizes');
image.src = source;
};
loader.src = source;
};
const startGifs = () => {
if (!canPlayGifs()) return;
const observer = new IntersectionObserver(
(entries) => {
entries.forEach((entry) => {
if (!entry.isIntersecting) return;
observer.unobserve(entry.target);
playGif(entry.target);
});
},
{ rootMargin: '100px' },
);
document.querySelectorAll('img[data-gsp-gif]').forEach((image) => observer.observe(image));
};
const scheduleGifs = () => setTimeout(startGifs, 3000);
if (document.readyState === 'complete') scheduleGifs();
else window.addEventListener('load', scheduleGifs, { once: true });
const define = (name, element) => {
if (!customElements.get(name)) customElements.define(name, element);
};
define('gsp-gallery', GspGallery);
define('gsp-offers', GspOffers);
define('gsp-sticky', GspSticky);
define('gsp-reviews', GspReviews);
define('gsp-cart', GspCart);
define('gsp-buy', GspBuy);